export default "__VITE_ASSET__c965acc0__"